import { NgModule } from '@angular/core';
import { DateToTimePipe } from './date-to-time.pipe';

@NgModule({
  imports: [],
  declarations: [DateToTimePipe],
  exports: [DateToTimePipe]
})
export class DateToTimeModule {}
